import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a48b558e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-license-container d-flex flex-column" }
const _hoisted_2 = { class: "lead font-weight-bold mb-3" }
const _hoisted_3 = { class: "slider-wrapper flex-1 col-md-6 shadow-sm" }
const _hoisted_4 = { class: "bubble-container" }
const _hoisted_5 = { class: "slider-bubble" }
const _hoisted_6 = { class: "slider-bubble-selected" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "slider-time" }, [
  /*#__PURE__*/_createElementVNode("b", { class: "slider-time-start" }, " 1 "),
  /*#__PURE__*/_createElementVNode("b", { class: "slider-time-end" }, " 30+ ")
], -1))
const _hoisted_8 = { class: "d-flex flex-column mx-1" }
const _hoisted_9 = { class: "content" }
const _hoisted_10 = { class: "mx-1" }
const _hoisted_11 = {
  key: 2,
  class: "d-flex justify-content-start flex-wrap"
}
const _hoisted_12 = { class: "token-price-wrapper d-flex flex-column mr-4 my-1" }
const _hoisted_13 = { class: "token-price-wrapper-title" }
const _hoisted_14 = { class: "d-flex flex-column" }
const _hoisted_15 = { class: "token-price-wrapper-subtitle" }
const _hoisted_16 = { class: "d-flex flex-row justify-content-between mt-1 w-full" }
const _hoisted_17 = { class: "token-price-wrapper-left my-auto" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_19 = { class: "d-flex flex-column token-price-wrapper-right my-auto" }
const _hoisted_20 = { class: "d-flex flex-column my-1" }
const _hoisted_21 = { class: "mb-1" }
const _hoisted_22 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Slider = _resolveComponent("Slider")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Message = _resolveComponent("Message")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Card, null, {
      content: _withCtx(() => [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$tc("product.advice.titleProductAdvice", { product: _ctx.productName })), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "bubble",
              style: _normalizeStyle({ left: `${_ctx.bubbleStyle(_ctx.selectedDays)}%` })
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("b", _hoisted_6, _toDisplayString(_ctx.selectedDays), 1)
              ])
            ], 4)
          ]),
          _createVNode(_component_Slider, {
            modelValue: _ctx.selectedDays,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedDays) = $event)),
            max: 30,
            min: 1,
            step: 1
          }, null, 8, ["modelValue"]),
          _hoisted_7
        ]),
        _createElementVNode("div", null, [
          (!_ctx.isPositiveFlexAdvice)
            ? (_openBlock(), _createBlock(_component_Message, {
                key: 0,
                class: "advice-banner mb-0",
                closable: false,
                severity: "error"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("product.advice.message.negativeSummary")), 1)
                  ]),
                  _createVNode(_component_Button, {
                    class: "advice-button p-button-success p-button-primary mx-1",
                    label: _ctx.$t('digitalAdvisor.button.lblSelectSubscription'),
                    onClick: _ctx.selectSubscription
                  }, null, 8, ["label", "onClick"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isPositiveFlexAdvice)
            ? (_openBlock(), _createBlock(_component_Message, {
                key: 1,
                class: "advice-banner",
                closable: false,
                severity: "success"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("product.advice.message.positiveSummary")), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isPositiveFlexAdvice)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.productName) + " | ", 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.$tc("product.advice.titleProductTokenUsage", _ctx.productUsageAdvice.tokensPerDay)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("product.advice.estimatedUsage")), 1),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_i18n_t, { keypath: "product.advice.lblYearlyTokenUsage" }, {
                          amount: _withCtx(() => [
                            _createElementVNode("b", null, _toDisplayString(_ctx.productUsageAdvice.tokensPerDay * _ctx.selectedDays * 12), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _hoisted_18,
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("b", null, _toDisplayString(_ctx.formatCurrency(_ctx.productUsageAdvice.totalCostsPerDay * _ctx.selectedDays * 12)), 1),
                        _createElementVNode("small", null, _toDisplayString(_ctx.$t("common.priceSummary.noVat")), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("h5", null, _toDisplayString(_ctx.$t("product.advice.buyTokens")), 1),
                  (_ctx.layoutStore.chatWidgetAvailable)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        class: "p-button-success p-button-raised w-100 mb-1",
                        label: _ctx.$t('product.advice.button.chatWithEmployee'),
                        onClick: _ctx.initChat
                      }, null, 8, ["label", "onClick"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("small", _hoisted_21, [
                    _createVNode(_component_i18n_t, { keypath: "common.support.contactUsAt" }, {
                      default: _withCtx(() => [
                        _createElementVNode("a", {
                          href: 'tel:' + _ctx.$t('common.support.phoneNumber')
                        }, _toDisplayString(_ctx.$t("common.support.phoneNumber")), 9, _hoisted_22)
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    })
  ]))
}